/**
 * 哈希
 */
import { defineStore } from 'pinia';
import { useHot } from '../useHot';
import network from '../network';

export const useHaxiStore = defineStore({
  id: 'haxi',
  state: () => {
    return {
      gameList: [],
      promoteRates: {
        up_one_rate: '0%',
        up_three_rate: '0%',
        up_two_rate: '0%',
      },
    };
  },
  getters: {},
  actions: {
    /**
     * 获取哈希的游戏列表
     */
    async haxiCollection(payload) {
      const { hotData } = useHot();
      const { userInfo, tenantInfo } = hotData;
      const { play_collection, play_name, play_cname } = payload.data;
      if (!payload.data.upper_id) {
        payload.data.upper_id = payload.data.upper_play_id;
      }
      const data = {
        tid: tenantInfo.value.tid,
        cust_id: userInfo.value.cust_id,
        status: play_collection,
        play_name: play_name,
        play_cname: play_cname,
        msg: JSON.stringify(payload.data),
      };
      try {
        const res = await network.request({
          cmdId: 480023,
          data: data,
        });
        if (res && res.type === 'success') {
          return Promise.resolve(res.data);
        } else {
          return Promise.reject(res.data);
        }
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },
    /**
     * 获取哈希的游戏列表
     */
    async getGameList(data: any = {}) {
      const { hotData } = useHot();
      const { tenantInfo, userInfo } = hotData;
      data = {
        tid: tenantInfo.value.tid,
        ...data,
      };
      if (userInfo.value.cust_id) {
        data.cust_id = userInfo.value.cust_id;
      }
      try {
        const res = await network.request({
          cmdId: 470001,
          data: data,
          headerType: 2,
          paramType: 0,
          isApiV2: false,
        });
        if (res && res.type === 'success') {
          this.gameList = res.data as any;
          return Promise.resolve(res.data);
        } else {
          return Promise.reject(res.data);
        }
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },

    /**
     * 获取投注记录列表信息
     */
    async reqBetHistoryList(payload) {
      const { hotData } = useHot();
      const { tenantInfo, userInfo } = hotData;
      // 470005
      // 参数:
      // tid、play_name、start_time、end_time(格式'2022-02-01 00:01:01')、
      // settle_satus(枚举字符类型 unsettle、settled)、
      // cust_code、page_start、num_per_page
      const data = {
        ...payload,
        tid: tenantInfo.value.tid,
        cust_code: userInfo.value.cust_code,
        num_per_page: payload.num_per_page,
        page_start: payload.page_start,
        start_time: payload.start_time,
        end_time: payload.end_time,
        play_name: payload.play_name,
        // settle_satus: 'unsettle'
        // type_id: payload.type_id
      };
      try {
        const res = await network.request({
          cmdId: 314502,
          // cmdId: 470005,
          data: data,
        });
        if (res && res.type === 'success') {
          return Promise.resolve(res.data);
        } else {
          return Promise.reject(res.data);
        }
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },

    setHaxiGames(data) {
      this.gameList = data;
    },
  },
});
